import { jsxs, jsx } from "react/jsx-runtime";
const IconHeartActiveSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M16.5 2A6.5 6.5 0 0 0 12 3.815 6.5 6.5 0 0 0 7.5 2 6.508 6.508 0 0 0 1 8.5C1 15.535 10.443 22 12 22s11-6.465 11-13.5C23 4.916 20.084 2 16.5 2Z" })
    ]
  }
);
export {
  IconHeartActiveSvg
};
